module.exports = __webpack_public_path__ + "static/img/alpaga-06.4b69c2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alpaga-06.png
// module id = 65
// module chunks = 0